import moment from 'moment'
import { changeFormatdate } from './formatdate'

export const checkType = (value) => {
    let data = new Date(value)

    if(data != 'Invalid Date'){
        data = changeFormatdate(moment(moment.utc(value).local().format(), 'YYYY-M-DD'))
    }else if(value == 'Female'){
        data = 'หญิง'
    }else if(value == 'Male'){
        data = 'ชาย'
    }else{
        data = value
    }
    
	return data
}